import { render, staticRenderFns } from "./InitialLoader.vue?vue&type=template&id=0f653ab6&scoped=true&"
import script from "./InitialLoader.vue?vue&type=script&lang=js&"
export * from "./InitialLoader.vue?vue&type=script&lang=js&"
import style0 from "./InitialLoader.vue?vue&type=style&index=0&id=0f653ab6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f653ab6",
  null
  
)

export default component.exports